const PIN =
  'M0 0c-2.4 0-3.3 2.4-2.9 4.8.4 1.9-.6 3.1-1.5 5-1.5 3-2.1 6.5-1.2 10.5L-4.2 26h8.4l1.4-5.7c.9-4-.3-7.5-1.2-10.5-.9-1.9-1.9-3.1-1.5-5C3.3 2.4 2.4 0 0 0z';

export default function BowlingIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <defs>
        <radialGradient id="bowl-icon-ball" cx="0.35" cy="0.3" r="0.8">
          <stop offset="0" stopColor="#9FD0FF" />
          <stop offset="0.45" stopColor="#2F8BFF" />
          <stop offset="1" stopColor="#0A2552" />
        </radialGradient>
      </defs>
      <g transform="translate(47 30) rotate(28)">
        <path d={PIN} fill="#F4F6FA" />
        <path d="M-3 6h6M-3.1 8.2h6.2" stroke="#E0262E" strokeWidth="1.5" />
      </g>
      <g transform="translate(54 34)">
        <path d={PIN} fill="#DCE1EA" />
        <path d="M-3 6h6M-3.1 8.2h6.2" stroke="#E0262E" strokeWidth="1.5" />
      </g>
      <path d="M34 22l3-5M38 26l5-2M31 20l-1-5" stroke="#FFD84D" strokeWidth="2.6" strokeLinecap="round" />
      <ellipse cx="25" cy="60" rx="15" ry="2.5" fill="#000" opacity="0.35" />
      <circle cx="25" cy="44" r="16" fill="url(#bowl-icon-ball)" />
      <path d="M14 39a12 12 0 0 1 9-8" stroke="#E6F2FF" strokeOpacity="0.7" strokeWidth="2.4" strokeLinecap="round" />
      <circle cx="31" cy="36.5" r="2" fill="#071331" />
      <circle cx="36" cy="40" r="2" fill="#071331" />
      <circle cx="29.5" cy="43.5" r="2.4" fill="#071331" />
    </svg>
  );
}
